import { Icon, type IconProps } from "@chakra-ui/react";

const FileIconStl = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<title>file icon stl</title>
			<path
				d="M4 4C4 1.79086 5.79086 0 8 0H24L36 12V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4Z"
				fill="#444CE7"
			/>
			<path
				opacity="0.3"
				d="M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z"
				fill="white"
			/>
			<path
				d="M15.6119 27.337C15.5863 27.0792 15.4766 26.8789 15.2827 26.7362C15.0888 26.5934 14.8256 26.522 14.4933 26.522C14.2674 26.522 14.0767 26.554 13.9212 26.6179C13.7656 26.6797 13.6463 26.766 13.5632 26.8768C13.4822 26.9876 13.4418 27.1133 13.4418 27.2539C13.4375 27.3711 13.462 27.4734 13.5153 27.5607C13.5707 27.6481 13.6463 27.7237 13.7422 27.7876C13.8381 27.8494 13.9489 27.9038 14.0746 27.9506C14.2003 27.9954 14.3345 28.0337 14.4773 28.0657L15.0653 28.2063C15.3509 28.2702 15.6129 28.3555 15.8516 28.462C16.0902 28.5685 16.2969 28.6996 16.4716 28.8551C16.6463 29.0107 16.7816 29.1939 16.8775 29.4048C16.9755 29.6158 17.0256 29.8576 17.0277 30.1303C17.0256 30.5309 16.9233 30.8782 16.7209 31.1722C16.5206 31.4641 16.2308 31.6911 15.8516 31.853C15.4744 32.0128 15.0195 32.0927 14.4869 32.0927C13.9585 32.0927 13.4982 32.0117 13.1062 31.8498C12.7163 31.6879 12.4116 31.4482 12.1921 31.1307C11.9748 30.8111 11.8608 30.4158 11.8501 29.945H13.1893C13.2042 30.1644 13.267 30.3477 13.3778 30.4947C13.4908 30.6396 13.641 30.7493 13.8285 30.8239C14.0181 30.8963 14.2322 30.9325 14.4709 30.9325C14.7053 30.9325 14.9087 30.8984 15.0813 30.8303C15.256 30.7621 15.3913 30.6673 15.4872 30.5458C15.5831 30.4244 15.631 30.2848 15.631 30.1271C15.631 29.9801 15.5874 29.8565 15.5 29.7564C15.4148 29.6562 15.2891 29.571 15.1229 29.5007C14.9588 29.4304 14.7575 29.3665 14.5188 29.3089L13.8061 29.13C13.2543 28.9957 12.8185 28.7859 12.4989 28.5004C12.1793 28.2148 12.0206 27.8303 12.0227 27.3466C12.0206 26.9503 12.1261 26.604 12.3391 26.3079C12.5543 26.0117 12.8494 25.7805 13.2244 25.6143C13.5994 25.4482 14.0256 25.3651 14.5028 25.3651C14.9886 25.3651 15.4126 25.4482 15.7749 25.6143C16.1392 25.7805 16.4226 26.0117 16.625 26.3079C16.8274 26.604 16.9318 26.9471 16.9382 27.337H15.6119ZM17.7093 26.5955V25.4545H23.085V26.5955H21.0811V32H19.7132V26.5955H17.7093ZM23.9703 32V25.4545H25.3541V30.859H28.1602V32H23.9703Z"
				fill="white"
			/>
		</Icon>
	);
};

export default FileIconStl;
